import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Autocomplete } from "@material-ui/lab"
import { useSnackbar } from "notistack"
import React, { useState } from "react"

const useStyles = makeStyles(theme => ({
    dialogContent: {
        padding: theme.spacing(3),
        minWidth: 400,
    },
    formField: {
        marginBottom: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            borderRadius: 15,
        },
    },
    dialogActions: {
        padding: theme.spacing(2, 3),
        gap: theme.spacing(1),
    },
    saveButton: {
        borderRadius: 15,
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#45a049",
        },
    },
    cancelButton: {
        borderRadius: 15,
        color: "#666",
    },
}))

const unidades = {
    U: "Unidade",
    G: "Grama",
    KG: "Quilograma",
    L: "Litro",
    ML: "Mililitro",
}

export default function DialogFTI({
    open,
    onClose,
    adicionarInsumo,
    insumosSelecionados = [],
    insumos,
}) {
    const classes = useStyles()
    const { enqueueSnackbar } = useSnackbar()
    const [insumoSelecionado, setInsumoSelecionado] = useState(null)
    const [quantidade, setQuantidade] = useState("")

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const insumosDisponiveis = insumos.filter(
        insumo => !insumosSelecionados.some(selected => selected.id === insumo.id)
    )

    const handleSave = () => {
        if (!insumoSelecionado) {
            alertStart("Selecione um insumo", "error")
            return
        }

        if (!quantidade || quantidade <= 0) {
            alertStart("Digite uma quantidade válida", "error")
            return
        }

        const novoInsumo = {
            ...insumoSelecionado,
            quantidade: `${quantidade}`,
        }

        adicionarInsumo(novoInsumo)
        handleClose()
    }

    const handleClose = () => {
        setInsumoSelecionado(null)
        setQuantidade("")
        onClose()
    }

    const handleQuantidadeChange = e => {
        const numeros = e.target.value.replace(/\D/g, "")
        setQuantidade(numeros)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: { borderRadius: 20 },
            }}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center">
                    Adicionar Insumo
                </Box>
            </DialogTitle>

            <DialogContent className={classes.dialogContent}>
                <Autocomplete
                    options={insumosDisponiveis}
                    getOptionLabel={option => option.nome}
                    value={insumoSelecionado}
                    onChange={(_, newValue) => setInsumoSelecionado(newValue)}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label="Selecione o insumo"
                            variant="outlined"
                            placeholder="Digite para buscar..."
                            className={classes.formField}
                        />
                    )}
                    renderOption={option => (
                        <Box>
                            <div style={{ fontWeight: 500 }}>{option.nome}</div>
                            <div style={{ fontSize: "0.8rem", color: "#666" }}>
                                Unidade: {unidades[option.unidade_medida] || option.unidade_medida}
                            </div>
                        </Box>
                    )}
                    noOptionsText="Nenhum insumo encontrado"
                />

                <TextField
                    fullWidth
                    label="Quantidade"
                    variant="outlined"
                    type="number"
                    value={quantidade}
                    onChange={handleQuantidadeChange}
                    onKeyDown={e => {
                        if ([".", ",", "e", "E", "+", "-"].includes(e.key)) {
                            e.preventDefault()
                        }
                    }}
                    className={classes.formField}
                    placeholder="Ex: 150"
                    inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        min: 1,
                        step: 1,
                    }}
                    InputProps={{
                        endAdornment: insumoSelecionado && (
                            <span style={{ color: "#666", marginLeft: 8 }}>
                                {unidades[insumoSelecionado.unidade_medida] ||
                                    insumoSelecionado.unidade_medida}
                            </span>
                        ),
                    }}
                    helperText={
                        insumoSelecionado
                            ? `Unidade de medida: ${
                                  unidades[insumoSelecionado.unidade_medida] ||
                                  insumoSelecionado.unidade_medida
                              }`
                            : "Selecione um insumo primeiro"
                    }
                />
            </DialogContent>

            <DialogActions className={classes.dialogActions}>
                <Button onClick={handleClose} className={classes.cancelButton}>
                    Cancelar
                </Button>
                <Button onClick={handleSave} variant="contained" className={classes.saveButton}>
                    Adicionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
